const ResearchCommittee = () => {
  return (
    <section style={{ marginTop: "100px", padding: "80px 0" }}>
      <div className="container">
        <h1>Research Committee</h1>
      </div>
    </section>
  );
};

export default ResearchCommittee;
